module.exports = __webpack_public_path__ + "static/media/wavm8s-019-yajo.659d1fc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-019-yajo.mp3
// module id = UUF4
// module chunks = 0